import { render, staticRenderFns } from "./PhpVersionModal.vue?vue&type=template&id=6339063d&scoped=true"
import script from "./PhpVersionModal.vue?vue&type=script&lang=js"
export * from "./PhpVersionModal.vue?vue&type=script&lang=js"
import style0 from "../../../../components/modal/BasicModal.scss?vue&type=style&index=0&id=6339063d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6339063d",
  null
  
)

export default component.exports